var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextInput',_vm._b({attrs:{"type":"number"},model:{value:(_vm.valueModel),callback:function ($$v) {_vm.valueModel=$$v},expression:"valueModel"}},'TextInput',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }